import { ArrowRight, CheckCircle2, Sparkles } from "lucide-react";

const benefits = [
  "Personalized weak-area focus",
  "Instant AI score breakdowns",
  "Exam-style practice environment",
];

const CtaPage = () => {
  return (
    <section className="overflow-hidden bg-gray-50 sm:grid sm:grid-cols-2 sm:items-center">
        <div className="relative h-full min-h-[360px] bg-gray-50 sm:min-h-[520px] lg:min-h-[640px]">
          <img
            alt="PrepNexis AI practice demo"
            src="/image/demo.gif"
            className="h-full w-full object-cover sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-se-[30px] md:h-[calc(100%_-_4rem)] md:rounded-se-[60px]"
          />
          <div className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-white/95 px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm backdrop-blur">
            <Sparkles className="h-4 w-4 text-fuchsia-800" />
            Live practice preview
          </div>
        </div>

        <div className="flex items-center p-8 md:p-12 lg:px-16 lg:py-24">
          <div className="max-w-xl">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-fuchsia-800">
              Smarter practice
            </p>
            <h2 className="mt-3 text-3xl font-black tracking-tight text-gray-950 sm:text-4xl">
              Turn every practice attempt into a clear improvement plan.
            </h2>

            <p className="mt-5 text-base leading-8 text-gray-600">
              PrepNexis gives you immediate scoring and practical feedback, so
              each mock test shows what to fix next and how your score is moving.
            </p>

            <div className="mt-6 grid gap-3">
              {benefits.map((benefit) => (
                <div key={benefit} className="flex items-center gap-3 text-gray-700">
                  <CheckCircle2 className="h-5 w-5 shrink-0 text-fuchsia-800" />
                  <span className="text-sm font-medium">{benefit}</span>
                </div>
              ))}
            </div>

            <a
              href="/signup"
              className="mt-8 inline-flex items-center justify-center gap-2 rounded-md bg-gradient-to-r from-gray-700 via-gray-900 to-black px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-gray-900/15 transition hover:-translate-y-0.5 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
            >
              <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-white/15">
                <Sparkles className="h-3.5 w-3.5" />
              </span>
              Get free trial
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
      </div>
    </section>
  );
};

export default CtaPage;
